export default "assets/images/menu-hover-mask-c0a4685d.svg";